import { Link } from "react-router-dom";
import { cn } from "@/shared/lib/cn";
import marca from "@/assets/marca.svg";

export interface BrandLogoProps {
  /** A dónde vuelve el logotipo. Por defecto, la tienda. */
  to?: string;
  /** Texto alternativo y nombre accesible del enlace. */
  label?: string;
  className?: string;
}

/**
 * El logotipo de la barra superior.
 *
 * Es un enlace, no una imagen suelta: el logotipo es "volver al inicio" en
 * todo sitio web, y quien lo usa con teclado o lector de pantalla espera
 * poder activarlo.
 *
 * El `alt` de la imagen se queda VACÍO a propósito y el nombre accesible
 * vive en el `aria-label` del enlace: si los dos llevaran texto, el lector
 * anunciaría la marca dos veces seguidas.
 */
export function BrandLogo({
  to = "/shop",
  label = "It's The Best",
  className,
}: BrandLogoProps) {
  return (
    <Link
      to={to}
      aria-label={label}
      className={cn(
        "inline-flex shrink-0 items-center rounded-ds-pill transition-opacity hover:opacity-80",
        className,
      )}
    >
      <img src={marca} alt="" className="h-5 w-auto sm:h-6" />
    </Link>
  );
}
